import { createAction, handleActions } from 'redux-actions';
import Agent from '../../api/Agent';
import { handleError } from '../user';

export const setTimesheets = createAction('SET_TIMESHEETS');
export const setTimesheetDisplayState = createAction('SET_TIMESHEET_DISPLAY_STATE');
export const resetTimesheetList = createAction('RESET_TIMESHEET_LIST');
export const setTimesheetPageNumber = createAction('SET_TIMESHEET_PAGE_NUMBER');
export const setTimesheetShiftIdFilter = createAction('SET_TIMESHEET_SHIFT_ID');
export const setTimesheetNurseFilter = createAction('SET_TIMESHEET_NURSE');
export const setTimesheetStatusFilter = createAction('SET_TIMESHEET_STATUS_FILTER');
export const setTimesheetLocFilter = createAction('SET_TIMESHEET_LOC_FILTER');
export const setTimesheetDeptFilter = createAction('SET_TIMESHEET_DEPT_FILTER');
export const setTimesheetFromDateFilter = createAction('SET_TIMESHEET_FORM_DATE_FILTER');
export const setTimesheetToDateFilter = createAction('SET_TIMESHEET_TO_DATE_FILTER');
export const setTimesheetSort = createAction('SET_TIMESHEET_SORT');
export const setTimesheetSortOrder = createAction('SET_TIMESHEET_SORT_ORDER');
export const setTimesheetOrgObj = createAction('SET_TIMESHEET_ORG_OBJ');
export const setTimesheetLocObj = createAction('SET_TIMESHEET_LOC_OBJ');
export const setTimesheetDeptObj = createAction('SET_TIMESHEET_DEPT_OBJ');
export const setTimesheetRatingDialogStatus = createAction('SET_RATING_DIALOG_STATUS');

const initialState = {
	department_id: '',
	departments: [],
	display: 'none',
	from_date: '',
	location_id: '',
	locations: [],
	nurse: '',
	organizations: [],
	page_no: 1,
	shift_id: '',
	showratingdailog: false,
	sort: '',
	sortOrder: '',
	status: '',
	timesheetList: {},
	to_date: ''
};

export default handleActions(
	{
		RESET_TIMESHEET_LIST: () => initialState,
		SET_RATING_DIALOG_STATUS: (state, action) => ({ ...state, showratingdailog: action.payload }),
		SET_TIMESHEET_DEPT_FILTER: (state, action) => ({ ...state, department_id: action.payload }),
		SET_TIMESHEET_DEPT_OBJ: (state, action) => ({ ...state, departments: action.payload }),
		SET_TIMESHEET_DISPLAY_STATE: (state, action) => ({ ...state, display: action.payload }),
		SET_TIMESHEET_FORM_DATE_FILTER: (state, action) => ({ ...state, from_date: action.payload }),
		SET_TIMESHEET_LOC_FILTER: (state, action) => ({ ...state, location_id: action.payload }),
		SET_TIMESHEET_LOC_OBJ: (state, action) => ({ ...state, locations: action.payload }),
		SET_TIMESHEET_NURSE: (state, action) => ({ ...state, nurse: action.payload }),
		SET_TIMESHEET_ORG_OBJ: (state, action) => ({ ...state, organizations: action.payload }),
		SET_TIMESHEET_PAGE_NUMBER: (state, action) => ({ ...state, page_no: action.payload }),
		SET_TIMESHEET_SHIFT_ID: (state, action) => ({ ...state, shift_id: action.payload }),
		SET_TIMESHEET_SORT: (state, action) => ({ ...state, sort: action.payload }),
		SET_TIMESHEET_SORT_ORDER: (state, action) => ({ ...state, sortOrder: action.payload }),
		SET_TIMESHEET_STATUS_FILTER: (state, action) => ({ ...state, status: action.payload }),
		SET_TIMESHEET_TO_DATE_FILTER: (state, action) => ({ ...state, to_date: action.payload }),
		SET_TIMESHEETS: (state, action) => ({ ...state, timesheetList: action.payload })
	},
	initialState
);

export const clearAllFilters = () => {
	return function (dispatch) {
		dispatch(setTimesheetShiftIdFilter(''));
		dispatch(setTimesheetNurseFilter(''));
		dispatch(setTimesheetStatusFilter(''));
		dispatch(setTimesheetLocFilter(''));
		dispatch(setTimesheetDeptFilter(''));
		dispatch(setTimesheetFromDateFilter(''));
		dispatch(setTimesheetToDateFilter(''));
		dispatch(setTimesheetSort(''));
		dispatch(setTimesheetSortOrder(''));
	};
};

export const setPageNumber = (pageNo) => {
	return function (dispatch) {
		dispatch(setTimesheetPageNumber(pageNo));
		dispatch(getTimesheetsWithPaging());
	};
};

export const getTimesheetsWithPaging = () => {
	return function (dispatch, getState) {
		dispatch(setTimesheets([]));
		dispatch(setTimesheetDisplayState('block'));

		Agent.getSupervisorTimesheetsWithPaging(getState().supervisorTimesheets).then((response) => {
			if (response.ok) {
				dispatch(setTimesheets(response.data));
			} else {
				dispatch(handleError(response));
			}

			dispatch(setTimesheetDisplayState('none'));
		});
	};
};

export const loadOrganizationObj = () => {
	return function (dispatch) {
		Agent.userinfo().then((response) => {
			if (response.ok) {
				Agent.organizationById(response.data.user_orgs[0].organization_id).then((response) => {
					if (response.ok) {
						dispatch(setTimesheetOrgObj(response.data));
						dispatch(setTimesheetLocObj(response.data.locations));
					}
				});
			} else {
				dispatch(handleError(response));
			}
		});
	};
};
